import React from 'react';

const OutlinedButton = ({ label, onClick, disabled = false,className='' }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`px-4 py-2 bg-white text-red-500 font-semibold border-2 border-red-500 capitalize ${className} rounded-lg shadow hover:bg-red-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-75 transition ease-in-out duration-150 ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >{label}</button>
  );
};

export default OutlinedButton;
